import { httpsCallable } from "firebase/functions";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { functions } from "../../config/firebaseConfig";

type Status = "idle" | "loading" | "success" | "error";

const UnsubscribePageComponent: React.FC = () => {
  const navigate = useNavigate();

  const [status, setStatus] = useState<Status>("idle");
  const [email, setEmail] = useState<string>("");

  // Extract token from URL
  const token = new URLSearchParams(window.location.search).get("token");

  // Validate token on mount
  useEffect(() => {
    if (!token) {
      setStatus("error");
    }
  }, []);

  const handleUnsubscribe = async () => {
    if (!token) {
      setStatus("error");
      return;
    }
  
    setStatus("loading");
  
    try {
      const userHandler = httpsCallable(functions, "authUserHandler");

      const result: any = await userHandler({
        type: "unsubscribe",
        email: "shashank@thelattice.in",
        unsubscribeId: token,
      });
  
      setEmail(result?.data?.email || "");
      setStatus("success");
    } catch (err) {
      console.error("Unsubscribe error:", err);
      setStatus("error");
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1120] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#111827] rounded-2xl shadow-lg p-6 text-center">

        {/* ================= INITIAL / LOADING ================= */}
        {(status === "idle" || status === "loading") && (
          <>
            {/* Back */}
            <div className="text-left mb-12 flex items-center">
              <button
                onClick={() => navigate("/")}
                className="text-gray-400 text-sm hover:text-white"
              >
                ← Go to home
              </button>
            </div>

            {/* Title */}
            <h1 className="text-white text-xl font-semibold mb-2">
              Unsubscribe from nudges
            </h1>

            {/* Description */}
            <p className="text-gray-400 text-sm mb-6">
              You will stop receiving marketing and promotional messages.
              You can always re-subscribe later.
            </p>

            {/* Button */}
            <button
              onClick={handleUnsubscribe}
              disabled={status === "loading"}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2.5 rounded-lg font-medium transition disabled:opacity-50"
            >
              {status === "loading"
                ? "Processing..."
                : "Yes, unsubscribe me"}
            </button>

            {/* Footer */}
            <p className="text-xs text-gray-500 mt-4">
              Changing your mind? You can resubscribe anytime.
            </p>
          </>
        )}

        {/* ================= SUCCESS ================= */}
        {status === "success" && (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-500/20">
                <span className="text-green-400 text-lg">✓</span>
              </div>
            </div>

            <h1 className="text-white text-lg font-semibold mb-2">
              You’ve been unsubscribed
            </h1>

            <p className="text-gray-400 text-sm mb-6">
              {email || "Your email"} will no longer receive updates.
            </p>

            <button
              onClick={() => navigate("/")}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2.5 rounded-lg font-medium transition"
            >
              Go to home
            </button>
          </>
        )}

        {/* ================= ERROR ================= */}
        {status === "error" && (
          <>
            <h1 className="text-red-400 text-lg font-semibold mb-2">
              Invalid or expired link
            </h1>

            <p className="text-gray-400 text-sm mb-6">
              This unsubscribe link is not valid or has already been used.
            </p>

            <button
              onClick={() => navigate("/")}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2.5 rounded-lg font-medium transition"
            >
              Go to home
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePageComponent;